export default __webpack_public_path__ + "static/media/svc.8fe4af81.svg";